import { Link } from "react-router-dom";
import { packagesInfo } from "../../../utils/packagesInfo";

export default function OrgPackages() {
  return (
    <section
      id="orgPackages"
      className={`w-full md:min-h-screen flex flex-col justify-center relative`}
    >
      {/* Absolute Background */}
      <img
        className={`absolute left-0 top-0 max-xl:hidden`}
        src="/img/home/Rectangle 14.png"
        alt="Absolute bg"
      />
      <div
        className={`myContainer w-full flex flex-col min-h-full justify-center gap-5 md:gap-20`}
      >
        <span className={`text-black text-2xl lg:text-4xl font-bold`}>
          پکیج های اشتراک سازمانی
        </span>
        <div
          className={`w-full flex max-2xl:flex-wrap justify-between max-2xl:justify-center max-w-[1440px] mx-auto gap-9`}
        >
          {packagesInfo?.slice(0, 4)?.map((itm, i) => (
            <div
              key={i}
              className={`w-full max-2xl:max-w-[402px] 2xl:w-[calc(25%-18px)] max-md:max-w-[300px] rounded-[20px] flex flex-col items-center gap-8 justify-between py-6 md:py-12 md:px-[70px] relative overflow-hidden`}
              style={{ backgroundColor: itm.bgColor }}
            >
              {/* Absolute Svg */}
              {itm.absIcon}
              <div
                className={`max-2xl:hidden absolute top-5 -left-10 -rotate-45 w-1/2 h-12 flex items-center justify-center`}
                style={{ backgroundColor: itm.bannerColor }}
              >
                <span className={`text-white font-semibold`}>
                  {itm?.title?.includes("آزمایشی")
                    ? "اشتراک ۷ روز"
                    : "اشتراک ۱ سال"}
                </span>
              </div>

              <span className={`text-black text-2xl font-black z-10`}>
                {itm?.title}
              </span>
              {itm?.icon}
              <div className={`flex flex-col gap-2 items-center`}>
                {itm?.specs?.map((jtm, j) => (
                  <span
                    key={j}
                    className="text-black font-semibold whitespace-nowrap"
                  >
                    {jtm}
                  </span>
                ))}
                <span className={`text-black font-semibold 2xl:hidden`}>
                  {itm?.title?.includes("آزمایشی")
                    ? "اشتراک ۷ روز"
                    : "اشتراک ۱ سال"}
                </span>
                <span className="text-black font-black">
                  قیمت: {itm?.price === 0 ? "رایگان" : itm?.price}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className={`w-full flex items-center justify-center`}>
          <Link className={`w-full md:w-[190px]`} to={"/packages"}>
            <button className="btn bg-myBlue text-white w-full">
              مشاهده همه پکیج ها
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}
